export default {
    excess: 'Franquia de responsabilidade',
    security: 'Depósito de segurança',
    fuel_policy: 'Política de combustível',
    like_for_like: 'Igual por igual',
    full_to_full: 'Cheio para cheio',
    mileage: 'Quilometragem: {mileage} milhas por aluguel',
    unlimited_mileage: 'Quilometragem ilimitada',
    non_refundable: 'Não reembolsável',
    free_cancellation_until: 'Cancelamento gratuito até {date}',
    cancellation_with_terms: 'Cancelamento {0} de acordo com ',
    t_c_text: 'Termos e Condições',
    two_free_extras: 'Dois extras gratuitos na retirada',
    glass_tyres_covered: 'Vidros e pneus cobertos',
    spec_fuel_petrol: 'gasolina',
    spec_fuel_petrol_diesel: 'gasolina/diesel',
};
